import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-blend-type-inner",
  "use": "icon-blend-type-inner-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"icon-blend-type-inner\"><path d=\"M10 3c-.7 0-1.4.2-2 .4-.6-.2-1.3-.4-2-.4-2.8 0-5 2.2-5 5s2.2 5 5 5c.7 0 1.4-.2 2-.4.6.3 1.3.4 2 .4 2.8 0 5-2.2 5-5s-2.2-5-5-5m-4 9c-2.2 0-4-1.8-4-4s1.8-4 4-4c.3 0 .6 0 .9.1C5.7 5 5 6.4 5 8s.7 3 1.9 3.9c-.3.1-.6.1-.9.1m4 0c-.3 0-.6 0-.9-.1C10.3 11 11 9.6 11 8s-.7-3-1.9-3.9c.3-.1.6-.1.9-.1 2.2 0 4 1.8 4 4s-1.8 4-4 4\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol